import { E as EmblaCarousel } from './embla-carousel.esm-CCUHK2kO.js';
import { a as addScrollBarListener } from './scrollbar-DHAl7Frv.js';
import { o as observeCarouselVisibility } from './visibility-1aJUVV5h.js';

const STACKED_MEDIA_QUERY = '(width < 48rem)';

class USPSlider extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType | undefined} */
  #embla;
  /** @type {ReturnType<typeof observeCarouselVisibility> | null} */
  #visibility = null;

  connectedCallback() {
    this.#visibility = observeCarouselVisibility(this, {
      onEnter: () => {
        const breakpoints = { '(min-width: 80rem)': { active: false } };

        if (this.hasAttribute('data-stack-on-mobile'))
          breakpoints[STACKED_MEDIA_QUERY] = { active: false };

        this.#embla = EmblaCarousel(this.querySelector('.embla__viewport'), {
          align: 'center',
          dragFree: true,
          direction: document.dir,
          slidesToScroll: 'auto',
          active: true,
          breakpoints,
        });

        addScrollBarListener(this.#embla, this.querySelector('.embla__scrollbar'));
      },
      getEmbla: () => this.#embla,
    });
  }

  disconnectedCallback() {
    this.#visibility?.disconnect();
    this.#embla?.destroy();
    this.#embla = undefined;
  }
}

customElements.define('usps-slider', USPSlider);
